/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_Max_RowsInputs */

const vi_shop_home_max_rows = /** @type {(inputs: Shop_Home_Max_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tối đa ${i?.max} dòng.`)
};

/**

* @param {Shop_Home_Max_RowsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_max_rows = /** @type {((inputs: Shop_Home_Max_RowsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Max_RowsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_max_rows(inputs)
});